import Link from "next/link";
import styles from './navbar.module.css';

type SubItemObj = {label: string, url: string};
type TitleItem = {label: string, url: string} | string;
export default function NavItem(props: {title: TitleItem, subitems?: unknown[]}) {

	if (typeof props.title === 'string') {

		return (

			<li key={props.title}>
				<span>{props.title}</span>
				<ul className={styles.subMenu}>
					{props?.subitems?.map((el, i: number) => {
						if (typeof el == 'object') {
							const _el = el as SubItemObj;
							return <li key={`${_el}_${i.toString()}`}><Link href={`${_el.url}`} passHref>{_el.label}</Link></li>
						}
						const _el = el as string;
						return <li key={`${_el}_${i.toString()}`}><Link href={`/sok?q=${_el}`} passHref>{_el}</Link></li>
					})}
				</ul>
			</li>

		)
	} else {	
		
		const _el = props.title as SubItemObj;
		return (
			<li key={_el.label}>
				<Link href={`${_el.url}`} passHref>{_el.label}</Link>
			</li>
		)
	}
}